// Yale College's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30 from Yale
// College Programs of Study, Yale's official catalog (catalog.yale.edu/ycps/
// majors-in-yale-college/): one list of every major with its degree as the
// catalog writes it, B.A., B.S. or "B.A. or B.S.". South Asian Studies is a
// second major only and carries no degree of its own. Certificates are left
// out. Curly apostrophes become straight ones. No flags: the college file
// holds no programs source. The KB list was the starting point; the catalog
// wins.
const majors = {
    "slug": "yale-university",
    "read": "2026-09-30",
    "intro": "Every major in Yale College Programs of Study, Yale's official catalog, with the degree it leads to. Certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Majors in Yale College",
            "source": {
                "label": "Yale College Programs of Study, Majors in Yale College",
                "url": "https://catalog.yale.edu/ycps/majors-in-yale-college/"
            },
            "majors": [
                {
                    "name": "African Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Archaeological Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Architecture",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Astrophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Black Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Classical Civilization",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Computer Science and Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science and Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science and Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Computing and Linguistics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Computing and the Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Planetary Sciences",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "East Asian Languages and Literatures",
                    "degree": "B.A."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics and Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering and Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Sciences (Chemical)",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Sciences (Electrical)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Engineering Sciences (Environmental)",
                    "degree": "B.A."
                },
                {
                    "name": "Engineering Sciences (Mechanical)",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Ethics, Politics, and Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Ethnicity, Race, and Migration",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "German Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Greek, Ancient and Modern",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History of Art",
                    "degree": "B.A."
                },
                {
                    "name": "History of Science, Medicine, and Public Health",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Mathematics and Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Modern Middle East Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Molecular Biophysics and Biochemistry",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Molecular, Cellular, and Developmental Biology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Near Eastern Languages and Civilizations",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics and Geosciences",
                    "degree": "B.S."
                },
                {
                    "name": "Physics and Philosophy",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Portuguese",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Russian, East European, and Eurasian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "South Asian Studies",
                    "degree": null,
                    "note": "Taken only as a second major."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Special Divisional Major",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Theater, Dance, and Performance Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
